import { type IObservableValue, observable, runInAction } from "mobx"

import { Model } from "@/lib/Model.ts"

import type { InitRuntimeConfigTaskState } from "@/lib/client/generated/TypeDefinitions.ts"
import type { ChangeEvent } from "react"

export type ServiceItemModelParams = {
  service: InitRuntimeConfigTaskState.Service
}

export class ServiceItemModel extends Model {
  readonly expanded = observable.box(false)
  readonly disabled = observable.box(false)
  readonly executionMethod = observable.box("")

  constructor(
    readonly service: InitRuntimeConfigTaskState.Service,
    readonly isEditing: IObservableValue<boolean>
  ) {
    super("ServiceItemModel")

    this.disabled.set(!!service.skipped)
    this.executionMethod.set(service.executionMethod)
  }

  reset = () => {
    runInAction(() => {
      this.disabled.set(!!this.service.skipped)
      this.executionMethod.set(this.service.executionMethod)
    })
  }

  setExpanded = (expanded: boolean) => {
    if (this.disabled.get()) {
      return
    }

    runInAction(() => {
      this.expanded.set(expanded)
    })
  }

  toDto = () => {
    return {
      ...this.service,
      skipped: this.disabled.get(),
      executionMethod: this.executionMethod.get()
    }
  }

  setDisabled = (disabled: boolean) => {
    runInAction(() => {
      this.disabled.set(disabled)
    })
  }

  handleExecutionMethodChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    runInAction(() => {
      this.executionMethod.set(e.target.value)
    })
  }
}